export const userListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "کد نمایندگی",
    value: "refCode",
  },
  {
    title: "نقش",
    value: "faRole",
  },
];
export const productStocksListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "وضعیت نمایش در سایت",
    value: "status",
  },
  {
    title: "وضعیت موجود بودن در سایت",
    value: "inventoryStatus",
  },
  {
    title: "آخرین تغییر موجودی",
    value: "inventoryStatusChangedAt",
  },
  {
    title: "شناسه",
    value: "sku",
  },
];
export const sldierListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "بخش",
    value: "faPart",
  },
  {
    title: "موقعیت",
    value: "faPosition",
  },
];

export const walletsTransactionColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "مبلغ",
    value: "amount",
  },
  {
    title: "توضیحات",
    value: "description",
  },
  ,
  {
    title: "شماره تراکنش",
    value: "trackingCode",
  },
  {
    title: "نوع تراکنش",
    value: "type",
  },
  {
    title: "کمیسیونه ؟",
    value: "isCommission",
  },
  {
    title: "وضعیت",
    value: "faPaymentStatus",
  },
  {
    title: "تاریخ",
    value: "date",
  },
];

export const articleListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "وضعیت",
    value: "faStatus",
  },
];
export const backupListColumns = [
  {
    title: "نام",
    value: "name",
  },
];
export const smsListColumns = [
  {
    title: "شرکت",
    value: "company",
  },
  {
    title: "پیش فرض فعال",
    value: "showIsDefault",
  },
];
export const provinceListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "تعداد شهر",
    value: "cityNumber",
  },
];

export const citiesListColumns = [
  {
    title: "نام شهر",
    value: "name",
  },
];

export const learnListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "وضعیت",
    value: "faStatus",
  },
  {
    title: "توضیحات",
    value: "desscription",
  },
  {
    title: "لینک ویدئو",
    value: "link",
  },
];
export const giftListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "حداقل قیمت قدیم فاکتور",
    value: "gtePrice",
  },
  {
    title: "شناسه محصول",
    value: "productSku",
  },
  {
    title: "وضعیت",
    value: "faStatus",
  },
];
export const couponListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "کد",
    value: "code",
  },
  {
    title: "نوع",
    value: "type",
  },
  {
    title: "مقدار",
    value: "value",
  },
  {
    title: "محدویت دارد؟",
    value: "isLimited",
  },
  {
    title: "رایگان برای حملو نقل؟",
    value: "setFreeShipping",
  },
  {
    title: "تعداد استفاده",
    value: "usedCount",
  },
  {
    title: "تاریخ اعتبار",
    value: "expireDate",
  },
  {
    title: "کوئری ها",
    value: "query",
  },
  {
    title: "وضعیت",
    value: "status",
  },
];

export const categoryListColumns = [
  {
    title: "نام",
    value: "name",
  },
];

export const learnCategoryListColumns = [
  {
    title: "نام",
    value: "name",
  },
];

export const productOptionsColumns = [
  {
    title: "نام",
    value: "value",
  },
];

export const variationOptionsColumns = [
  {
    title: "مقدار",
    value: "value",
  },
  {
    title: "قیمت",
    value: "price",
  },
  {
    title: "عکس",
    value: "image",
  },
  {
    title: "توضیحات",
    value: "desc",
  },
  {
    title: "نوع تخفیف",
    value: "discountType",
  },
  {
    title: "تخفیف",
    value: "discount",
  },
  {
    title: "موجودی",
    value: "inventoryStatus",
  },
  {
    title: "شناسه یکتا",
    value: "sku",
  },
];

export const featuresColumns = [
  {
    title: "عنوان",
    value: "title",
  },
  {
    title: "مقدار",
    value: "value",
  },
];

export const productListColumns = [
  {
    title: "عکس",
    value: "showMainImage",
  },
  {
    title: "نام",
    value: "name",
  },
  {
    title: "قیمت پایه (تومان)",
    value: "basePrice",
  },
  {
    title: "تخفیف",
    value: "showDiscountPercent",
  },
  {
    title: "دسته بندی",
    value: "showCategories",
  },
  {
    title: "وضعیت",
    value: "faStatus",
  },
  {
    title: "موجودی",
    value: "faInventoryStatus",
  },
  {
    title: "آپشن",
    value: "showOptionsInfo",
  },
  {
    title: "موجودی انبار",
    value: "stock",
  },
];

export const barcodesListColumns = [
  {
    title: "شماره سفارش",
    value: "trackingCode",
  },
  {
    title: "بارکد",
    value: "barcode",
  },
];
export const notFoundBarcodesListColumns = [
  {
    title: "شماره سفارش",
    value: "trackingCode",
  },
];

export const shippingListColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "قیمت",
    value: "faPrice",
  },
  {
    title: "پیش فرض",
    value: "faIsDefault",
  },
  {
    title: "رایگان برای همه",
    value: "faFreeForAll",
  },
  {
    title: "وضعیت",
    value: "faStatus",
  },
];

export const usersReportsColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "نقش",
    value: "role",
  },
  {
    title: "ناخالص خرید شخصی محصولات (قیمت قدیم)",
    value: "old_totalProductsPriceSum",
  },
  {
    title: "ناخالص خرید لینک ارجاع محصولات (قیمت قدیم)",
    value: "old_refTotalProductsPriceSum",
  },
  {
    title: "مجموع نا خالص (قیمت قدیم)",
    value: "_ref_user_old_totalProductsPrice",
  },
  {
    title: "مجموع پرداختی شخصی",
    value: "finalPriceSum",
  },
  {
    title: "مجموع پرداختی لینک ارجاع",
    value: "refFinalPriceSum",
  },
  {
    title: "تعداد سفارش",
    value: "ordersCount",
  },
];
export const usersSalesMounthlyReportsColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "نقش",
    value: "role",
  },
  {
    title: "بهمن ناخالص",
    value: "bahmanNaKhales",
  },
  {
    title: "بهمن",
    value: "bahman",
  },
  {
    title: "اسفند ناخالص",
    value: "esfandNaKhales",
  },
  {
    title: "اسفند",
    value: "esfand",
  },
  {
    title: "فروردین ناخالص",
    value: "farvardinNaKhales",
  },
  {
    title: "فروردین",
    value: "farvardin",
  },
  {
    title: "اردیبهشت ناخالص",
    value: "ordibeheshtNaKhales",
  },
  {
    title: "اردیبهشت",
    value: "ordibehesht",
  },
  {
    title: "خرداد ناخالص",
    value: "khordadNaKhales",
  },
  {
    title: "خرداد",
    value: "khordad",
  },
  {
    title: "تیر ناخالص",
    value: "tirNaKhales",
  },
  {
    title: "تیر",
    value: "tir",
  },
  {
    title: "مرداد ناخالص",
    value: "mordadNaKhales",
  },
  {
    title: "مرداد",
    value: "mordad",
  },
  {
    title: "شهریور ناخالص",
    value: "shahrivarNaKhales",
  },
  {
    title: "شهریور",
    value: "shahrivar",
  },
  {
    title: "مهر ناخالص",
    value: "mehrNaKhales",
  },
  {
    title: "مهر",
    value: "mehr",
  },
  {
    title: "آبان ناخالص",
    value: "abanNaKhales",
  },
  {
    title: "آبان",
    value: "aban",
  },
  {
    title: "آذر",
    value: "azar",
  },
  {
    title: "آذر ناخالص",
    value: "azarNaKhales",
  },
  {
    title: "دی",
    value: "dey",
  },
  {
    title: "دی ناخالص",
    value: "deyNaKhales",
  },
  {
    title: "بهمن",
    value: "bahman1403",
  },
  {
    title: "بهمن ناخالص",
    value: "bahman1403NaKhales",
  },
  {
    title: "اسفند",
    value: "esfand1403",
  },
  {
    title: "اسفند ناخالص",
    value: "esfand1403NaKhales",
  },
  {
    title: "فروردین",
    value: "farvardin404",
  },
  {
    title: "فروردین ناخالص",
    value: "farvardin404NaKhales",
  },
  {
    title: "اردیبهشت",
    value: "ordibehesht404",
  },
  {
    title: "اردیبهشت ناخالص",
    value: "ordibehesht404NaKhales",
  },
  {
    title: "خرداد",
    value: "khordad404",
  },
  {
    title: "خرداد ناخالص",
    value: "khordad404NaKhales",
  },
  {
    title: "تیر",
    value: "tir404",
  },
  {
    title: "تیر ناخالص",
    value: "tir404NaKhales",
  },
  {
    title: "مرداد",
    value: "mordad404",
  },
  {
    title: "مرداد ناخالص",
    value: "mordad404NaKhales",
  },
  {
    title: "شهریور",
    value: "shahrivar404",
  },
  {
    title: "شهریور ناخالص",
    value: "shahrivar404NaKhales",
  },
  {
    title: "مهر",
    value: "mehr404",
  },
  {
    title: "مهر ناخالص",
    value: "mehr404NaKhales",
  },
  {
    title: "ماه جاری ناخالص",
    value: "_ref_user_old_totalProductsPrice",
  },
  {
    title: "ماه جاری",
    value: "_ref_user_finalPrice",
  },
];
export const usersOldReportsColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "موبایل",
    value: "mobile",
  },
  {
    title: "نقش",
    value: "role",
  },
  {
    title: "ناخالص تیر",
    value: "tirNaKhales",
  },
  {
    title: "خالص تیر",
    value: "tir",
  },
  {
    title: "ناخالص مرداد",
    value: "mordadNaKhales",
  },
  {
    title: "خالص مرداد",
    value: "mordad",
  },
  {
    title: "شهریور ناخالص",
    value: "shahrivarNaKhales",
  },
  {
    title: "شهریور خالص",
    value: "shahrivar",
  },
  {
    title: "ناخالص کل",
    value: "totalNakhales",
  },
];

export const productsReportsColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "دسته بندی",
    value: "categories",
  },
  {
    title: "قیمت خرید",
    value: "buyPrice",
  },
  {
    title: "قیمت فروش (قیمت قدیم در بازه)",
    value: "basePrice",
  },
  {
    title: "مجموع قیمت",
    value: "totalPrice",
  },
  {
    title: "تعداد",
    value: "total",
  },
  {
    title: "شناسه",
    value: "productSku",
  },
];
export const usersCommisionsReportsColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "شماره تماس",
    value: "mobile",
  },
  {
    title: "مجموع",
    value: "totalCommission",
  },
  {
    title: "تعداد ",
    value: "count",
  },
];
export const ordersUniqueMobileReportsColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "شماره تماس",
    value: "mobile",
  },
  {
    title: "تعداد سفارش",
    value: "orderCount",
  },
  {
    title: "مجموع خرید",
    value: "sumTotalPrice",
  },
];

export const UserFirstCustomerReportsColumns = [
  {
    title: "شماره تماس",
    value: "mobile",
  },
  {
    title: "نام",
    value: "name",
  },
  {
    title: "آدرس",
    value: "address",
  },
  {
    title: "مبلغ پرداختی",
    value: "finalPriceWithoutShipping",
  },
  {
    title: "شماره سفارش",
    value: "trackingCode",
  },
  {
    title: "تاریخ پرداخت",
    value: "paymentDate",
  },
];
export const totalUserCustomerCountReportsColumns = [
  {
    title: "شماره تماس",
    value: "mobile",
  },
  {
    title: "نام",
    value: "name",
  },
  {
    title: "تعداد",
    value: "count",
  },
];
export const userCustomersReportsColumns = [
  {
    title: "شماره تماس",
    value: "mobile",
  },
  {
    title: "نام",
    value: "name",
  },
  {
    title: "تعداد سفارش",
    value: "sumTotalOrders",
  },
  {
    title: "مجموع پرداختی",
    value: "sumFinalPrice",
  },
];
export const inactiveUserCustomersReportsColumns = [
  {
    title: "نام مشتری",
    value: "name",
  },
  {
    title: "شماره تماس",
    value: "mobile",
  },
  {
    title: "آخرین خرید",
    value: "lastPaymentDateText",
  },
  {
    title: "روز از آخرین خرید",
    value: "daysSinceLastOrder",
  },
  {
    title: "تعداد سفارش",
    value: "sumTotalOrders",
  },
  {
    title: "مجموع خرید",
    value: "sumFinalPriceText",
  },
  {
    title: "مشاور",
    value: "consultantName",
  },
  {
    title: "شماره تماس مشاور",
    value: "consultantMobile",
  },
];
export const socialMediaCustomerReportsColumns = [
  {
    title: "نام",
    value: "name",
  },
  {
    title: "شماره تماس",
    value: "mobile",
  },
  {
    title: "تعداد سفارش",
    value: "orderCount",
  },
  {
    title: "مجموع مبلغ",
    value: "totalAmount",
  },
  {
    title: "اخرین تاریخ ثبت سفارش",
    value: "lastPaymentDate",
  },
];
export const faqListColumns = [
  {
    title: "عنوان",
    value: "title",
  },
  {
    title: "بخش",
    value: "part",
  },
  {
    title: "اولویت",
    value: "priority",
  },
];

export const fileListColumns = [
  {
    title: "تصویر",
    value: "showImage",
  },
  {
    title: "نام فایل",
    value: "name",
  },
];
